"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildInEvaluation = void 0;
var BuildInEvaluation = /** @class */ (function (_super) {
    __extends(BuildInEvaluation, _super);
    function BuildInEvaluation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "BuildInEvaluation";
        _this.behaviour = function () {
            _this.push(function (_) { return "behaviour"; });
        };
        _this.gaiaquery = function () {
            _this.push(function (_) { return "gaiaquery"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return BuildInEvaluation;
}(Array));
exports.BuildInEvaluation = BuildInEvaluation;
//# sourceMappingURL=BuildInEvaluation.js.map